import {combineReducers} from 'redux';
import {menuReducer} from "./menuReducer";

export const root_reducer = combineReducers({
     menuReducer
});